import type { ExternalBankAccountForm, ExternalBankAccountFormDirty } from '@klear/bank-account/wire.client'
import { createEntityFormStateHelpers, type EntityFormErrorMap } from '@klear/ui/entity-form-state'

type AddressForm = ExternalBankAccountForm['address']
type TopLevelField = Extract<Exclude<keyof ExternalBankAccountForm, 'address'>, string>
type AddressField = Extract<keyof AddressForm, string>

export type ExternalBankAccountFormFieldPath = TopLevelField | `address.${AddressField}`
export type ExternalBankAccountFormFieldValue = ExternalBankAccountForm[TopLevelField] | AddressForm[AddressField]

const helpers = createEntityFormStateHelpers<ExternalBankAccountForm, ExternalBankAccountFormDirty>()

export const markExternalBankAccountFormDirtyPaths = helpers.markDirtyPaths as (
  draft: Parameters<typeof helpers.markDirtyPaths>[0],
  paths: ExternalBankAccountFormFieldPath | readonly ExternalBankAccountFormFieldPath[]
) => void

export const setExternalBankAccountFormField = helpers.setField as (
  draft: Parameters<typeof helpers.setField>[0],
  path: ExternalBankAccountFormFieldPath,
  value: ExternalBankAccountFormFieldValue
) => void

export const clearExternalBankAccountFormErrors = helpers.clearErrors as (
  errors: EntityFormErrorMap,
  paths: ExternalBankAccountFormFieldPath | readonly ExternalBankAccountFormFieldPath[]
) => EntityFormErrorMap
